import { Component, OnInit, ViewChild } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import { DxHtmlEditorComponent, DxHtmlEditorModule } from 'devextreme-angular';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { LinkSettingView } from '../../interfaces/link-setting-view.interface';
import { ApplicationSettingsService } from '../../services/application-settings.service';
import { DxoToolbarModule, DxiItemModule, DxoMediaResizingModule } from 'devextreme-angular/ui/nested';
import { NgIf } from '@angular/common';
import { SanitizePipe } from '../../pipes/santizehtml.pipe';
import { UnescapePipe } from '../../pipes/html_unescape.pipe';

@Component({
    selector: 'al-description-modal',
    templateUrl: './description-modal.component.html',
    styleUrls: ['./description-modal.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        DxHtmlEditorModule,
        DxoToolbarModule,
        DxiItemModule,
        DxoMediaResizingModule,
		SanitizePipe,
		UnescapePipe
    ],
})
export class DescriptionModalComponent implements OnInit {
	@ViewChild('editTitle')
	editorTitle: DxHtmlEditorComponent;

	@ViewChild('editDescription')
	editorDescription: DxHtmlEditorComponent;

	public showDialog: boolean = false;
	title: string = 'no title given';
	originalContent: string;
	content: string;
	canManageApplicationLinkAdministration: boolean = false;
	id: number;
	result$: Subject<{ content: string; type: string }>;

	popupVisible: boolean;

	toolbarButtonOptions: any = {
		text: 'Show markup',
		stylingMode: 'text',
		onClick: () => (this.popupVisible = true),
	};

	constructor(private asamcoUserService: AsamcoUserService, private applicationSettingService: ApplicationSettingsService) {}

	ngOnInit(): void {
		this.asamcoUserService.hasAssignedPermission('AL3_ADMINISTRATION').then(result => (this.canManageApplicationLinkAdministration = result));
	}

	public show(setting: LinkSettingView): Observable<{ content: string; type: string }> {
		this.result$ = new Subject<{ content: string; type: string }>();
		const title = setting.displayName;
		if (title !== null && title.length > 0) this.title = title;
		else this.title = 'no title given';

		const originalContent = setting.settingDescription;
		if (originalContent !== null && originalContent.length > 0) this.originalContent = originalContent;
		else this.originalContent = '<h5>No content was given</h5>';
		this.content = this.originalContent;
		this.showDialog = true;

		this.id = setting.id;
		return this.result$.asObservable();
	}

	public cancel(): void {
		this.result$.complete();
		this.showDialog = false;
	}

	public saveContent(): void {
		//By default the html-edit includes HTML tags, we definitly dont want those to be displayed, so I use this to manually remove any HTML tags
		var html = this.editorTitle.value;
		var div = document.createElement('div');
		div.innerHTML = html;
		var text = div.textContent || div.innerText || '';

		this.applicationSettingService.editTitle(this.id, text).subscribe(e => {
			this.result$.next({ content: text, type: 'title' });
			//this.result$.next(this.editorTitle.value);
			this.result$.complete();

			this.applicationSettingService.editDescription(this.id, this.editorDescription.value).subscribe(e => {
				this.result$.next({ content: this.editorDescription.value, type: 'description' });
				this.result$.complete();
				this.showDialog = false;

				Swal.fire({ icon: 'success', text: 'Succesfully updated content' });
			});
		});
	}
}
